export default `
<div class="activity-feed-wrapper">
  <div class="profile-activity-feed-item activity-comment_activity" ng-repeat="comment in commentsStore.feedItems" >
    <div class="activity-feed-content" >
      <div class="profile-thumb" style="background: url({{comment.user.avatar_url}});background-size:cover;"></div>
      <div class="activity-header">
      <a ui-sref="profile.about({profileId: comment.user.slug})">{{comment.user.name}}</a>
      <ut-dynamic-tooltip [user]="comment.user" tooltipType="user">
        <span tabindex="0"
              class="fa fa-info-circle"
              role="button"
              aria-label="{{ 'Open ' + comment.user.name + ' tooltip' }}"></span>
      </ut-dynamic-tooltip>
        commented on <a ng-href="{{stateStore(comment.commentable)}}">{{cs.getCommentableLabel(comment.commentable)}}</a>.
      </div>
    </div>
    <div class="time-stamp">{{comment.published_at | relativeDate}}</div>

    <article class="content-extra" ng-bind-html='comment.content | uMarkdown | trustAsHtml'></article>

  </div>
</div>
<ut-load-more (load-more)="commentsStore.loadMore()" [is-loading]="commentsStore.isLoading" [is-last-page]="commentsStore.isLastPage"></ut-load-more>
`;
